<script>
import baseMixin from '@/mixins/baseMixin'
import BookingDetailsTabDays from './booking-details-tab-days.vue'
import BookingDetailsTabHistory from './booking-details-tab-history.vue'
import BookingDetailsTabConfirmations from './booking-details-tab-confirmations.vue'
import BookingDetailsTabDetails from './booking-details-tab-details.vue'

export default {
  name: 'BookingDetailsTabGroup',
  components: {
    BookingDetailsTabDays,
    BookingDetailsTabHistory,
    BookingDetailsTabConfirmations,
    BookingDetailsTabDetails,
  },
  mixins: [baseMixin],
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      tab: null,
    }
  },
  computed: {
    compTabs() {
      return [
        { tab: 'details', title: this.$t('booking.details.tabs.detailsLabel') },
        {
          tab: 'days',
          title: this.$t('booking.details.tabs.daysLabel', [
            this.booking.dates.length,
          ]),
        },
        { tab: 'history', title: this.$t('booking.details.tabs.historyLabel') },
        {
          tab: 'confirmations',
          title: this.$t('booking.details.tabs.confirmationsLabel'),
        },
      ]
    },
  },
}
</script>

<template>
  <div>
    <v-tabs v-model="tab" class="mx-n4-">
      <v-tab
        v-for="item in compTabs"
        :key="item.tab"
        class="text-capitalize"
        style="letter-spacing: normal;"
      >
        {{ item.title }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat>
          <BookingDetailsTabDetails :booking="booking" class="mt-4" />
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <BookingDetailsTabDays :booking="booking" class="mt-4" />
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <BookingDetailsTabHistory :booking="booking" class="mt-4" />
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <BookingDetailsTabConfirmations :booking="booking" class="mt-4" />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
